import {
  ListBoxItem as AriaListBoxItem,
  Collection,
  Header,
  ListBoxItemProps,
  ListBoxSection,
  SectionProps,
  composeRenderProps,
} from "react-aria-components";
import { tv } from "tailwind-variants";
import { cn } from "@/utils/helpers";

export const dropdownItemStyles = tv({
  base: "group flex items-center gap-3 cursor-default select-none py-[5px] px-[8px] selected:pr-[9px] rounded-none outline outline-0 text-sm forced-color-adjust-none no-underline [&[href]]:cursor-pointer [-webkit-tap-highlight-color:transparent]",
  variants: {
    isDisabled: {
      false: "text-co-text2",
      true: "text-co-faint forced-colors:text-[GrayText]",
    },
    isPressed: {
      true: "bg-co-hover",
    },
    isFocused: {
      true: "bg-co-hover text-co-text forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]",
    },
  },
  compoundVariants: [
    {
      isFocused: false,
      isOpen: true,
      className: "bg-co-hover",
    },
  ],
});

export function DropdownItem(props: ListBoxItemProps) {
  let textValue =
    props.textValue ||
    (typeof props.children === "string" ? props.children : undefined);
  return (
    <AriaListBoxItem
      {...props}
      textValue={textValue}
      className={dropdownItemStyles}
    >
      {composeRenderProps(props.children, (children) => (
        <>
          <span
            className={cn(
              "flex items-center flex-1 gap-[12px] font-normal truncate group-selected:font-semibold font-medium!",
              props.className,
            )}
          >
            {children}
          </span>
          {/* <span className="flex items-center w-5">
            {isSelected && <Check className="w-4 h-4" />}
          </span> */}
        </>
      ))}
    </AriaListBoxItem>
  );
}

export interface DropdownSectionProps<T> extends SectionProps<T> {
  title?: string;
  items?: any;
}

export function DropdownSection<T extends object>(
  props: DropdownSectionProps<T>,
) {
  return (
    <ListBoxSection className="first:-mt-[5px] after:content-[''] after:block after:h-[5px] last:after:hidden">
      <Header className="text-[11px] font-semibold uppercase tracking-wider text-co-faint px-3 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-[var(--co-dropdown-panel-bg)] border-y border-y-co-line [&+*]:mt-1">
        {props.title}
      </Header>
      <Collection items={props.items}>{props.children}</Collection>
    </ListBoxSection>
  );
}
